import { pipe, prop, ifElse, path } from 'ramda';

import { DATE } from 'store/examinations';

const parseDate = (date) => (date ? new Date(date).valueOf() : 0);

export const getExamDate = ifElse(prop(DATE), pipe(prop(DATE), parseDate), pipe(path(['meta', 'created']), parseDate));
